import Axios from "axios";
import {
  antdMessageError,
  antdMessageInfo,
  antdMessageSuccess,
  buildErrorObject,
  errorHandler,
} from "../../helpers/Utils";

export const getAutosys = (page, filterParams) => async (dispatch) => {
  try {
    console.time();
    dispatch({ type: "LOADING_CUSTOM" });
    const { data } = await Axios.get(
      `/api/v1/autosys.json?page=${page}${filterParams}`
    );
    console.timeEnd();
    console.log({ data });
    dispatch({
      type: "GET_CUSTOMS",
      payload: { ...data, current: "Autosys" },
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const getAutosysItem = (id) => async (dispatch) => {
  try {
    const { data } = await Axios.get(`/api/v1/autosys/${id}`);
    if (!data.success) throw new Error("ERR");
    if (data.data?.api_error) antdMessageError(data.data.api_error);
    dispatch({
      type: "UPDATE_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const putAutosys = (params) => async (dispatch) => {
  try {
    antdMessageInfo();
    const updating = params.id;
    const autosys = { ...params };
    const normalizeCategoryIds = (ids) =>
      (Array.isArray(ids) ? ids : [])
        .map((id) => Number(id))
        .filter((id) => Number.isInteger(id) && id > 0);

    const includedCategoryIds = normalizeCategoryIds(autosys?.included_category_ids);
    const excludedCategoryIds = normalizeCategoryIds(autosys?.excluded_category_ids);

    autosys.included_category_ids = includedCategoryIds;
    autosys.excluded_category_ids = excludedCategoryIds;
    delete autosys.autosys_category_relations;

    autosys.parameters = {
      ...(autosys.parameters || {}),
    };
    delete autosys.parameters.included_category_ids;
    delete autosys.parameters.excluded_category_ids;

    const normalizeSku = (sku) => (sku || "").toString().trim().toUpperCase();
    const normalizeAutosysProducts = (products, defaultExcluded = false) =>
      (Array.isArray(products) ? products : [])
        .map((product) => ({
          ...product,
          autosys_id: product?.autosys_id || updating || null,
          sku: normalizeSku(product?.sku || product?.value),
          excluded:
            product?.excluded !== undefined
              ? product.excluded
              : defaultExcluded,
        }))
        .filter((product) => product.sku);

    const autosysProducts = normalizeAutosysProducts(params.autosys_products, false);

    const autosysProductsByKey = {};
    autosysProducts.forEach((product) => {
      const key = `${product.excluded ? "1" : "0"}-${product.sku}`;
      if (!autosysProductsByKey[key] || product.id) {
        autosysProductsByKey[key] = product;
      }
    });

    const overlappingCategoryIds = includedCategoryIds.filter((id) =>
      excludedCategoryIds.includes(id)
    );

    autosys.autosys_products_attributes = Object.values(autosysProductsByKey);
    delete autosys.autosys_products;
    delete autosys.included_autosys_products;
    delete autosys.excluded_autosys_products;
    delete autosys.full_name;

    const validateAutosys = () => {
      let errors = {};
      if (!autosys.rule_title) errors.rule_title = "Cannot be empty";
      if (!autosys.auto_type) errors.auto_type = "Cannot be empty";
      if (!autosys.order_shop_ids || autosys.order_shop_ids.length == 0) errors.order_shop_ids = "Cannot be empty";
      if (!autosys.period || !autosys.period[0])
        errors.period = "Cannot be empty";
      return errors;
    };

    const errors = validateAutosys();
    if (overlappingCategoryIds.length > 0) {
      errors.included_category_ids = "Categories cannot be both included and excluded";
      errors.excluded_category_ids = "Categories cannot be both included and excluded";
    }
    if (Object.keys(errors).length > 0) {
      antdMessageError("Validation errors");
      return { success: false, errors };
    }
    const { data } = await Axios({
      url: `/api/v1/autosys/${updating ? updating : ""}`,
      data: { autosys },
      method: updating ? "PUT" : "POST",
    });
    console.log({ data });
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    dispatch({
      type: updating ? "UPDATE_CUSTOM" : "POST_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return {
      success: false,
      errors: buildErrorObject(err?.response?.data?.errors),
    };
  }
};

export const duplicateAutosys = (id) => async (dispatch) => {
  try {
    const { data } = await Axios.post(
      `/api/v1/autosys/${id}/autosys_duplicate`
    );
    console.log({ data });
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    dispatch({
      type: "POST_CUSTOM",
      payload: data.data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

export const removeAutosys = (id) => async (dispatch) => {
  try {
    const { data } = await Axios.delete(`/api/v1/autosys/${id}`);
    console.log({ data });
    if (!data.success) throw new Error("ERR");
    antdMessageSuccess();
    dispatch({
      type: "REMOVE_CUSTOM",
      payload: id,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdMessageError();
    return { success: false };
  }
};

//
export const getAutosysOptions = () => async (dispatch) => {
  try {
    const getBrands = () =>
      Axios.get(`/api/v1/order_shops`).then((res) => {
        return res.data.shops;
      });

    Promise.all([getBrands()]).then((res) => {
      console.log("Response: ", { res });
      dispatch({
        type: "SET_OPTIONS",
        payload: {
          shops: res[0],
          // families: res[1],
        },
      });
    });
    return { success: true };
  } catch (err) {
    console.log("ERROR ", err);
    return { success: false };
  }
};
